// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__hjsgb","image":"Header_image__2UC8W","name":"Header_name__2LGPN","info":"Header_info__-tKzR","infoRow":"Header_infoRow__2m4NJ"};